import { useState, useEffect } from "react";
import { useParams, useLocation,  useNavigate} from "react-router-dom";
import Lottie from "lottie-react";
import successAnim from "../animations/success.json";
import EssayLayout from "../components/EssayLayout";

export default function EssayPage() {

  const { id: teacherId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const moduleId = queryParams.get("module_id");
  const isReviewMode = queryParams.get("review") === "true";

  const [essays, setEssays] = useState([]);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(true);
  const [essayType, setEssayType] = useState("model_papers");
  const [subjectName, setSubjectName] = useState("");
  const [teacherName, setTeacherName] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [score, setScore] =  useState(0);
  const [historyReviewMode, setHistoryReviewMode] = useState(false);
  const EXAM_TIME = 5 * 60;
  const [timeLeft, setTimeLeft] = useState(EXAM_TIME);
  const [showPremium, setShowPremium] = useState(false);
  const [submitting, setSubmitting] = useState(false);

      useEffect(() => {

        if (!isReviewMode)
          return;

        const reviewData =
          JSON.parse(
            localStorage.getItem(
              "review_essay_data"
            )
          );

        if (!reviewData)
          return;

        if (reviewData.essayType) {

          setEssayType(
            reviewData.essayType
          );

        }

        setAnswers(
          reviewData.answers || {}
        );

        if (
          reviewData.subject_name
        ) {

          setSubjectName(
            reviewData.subject_name
          );

        }

        if (
          reviewData.teacher_name
        ) {

          setTeacherName(
            reviewData.teacher_name
          );

        }

        if (
          reviewData.marks !==
          undefined
        ) {

          setScore(
            reviewData.marks
          );

          setSubmitted(true);

        }

        setHistoryReviewMode(
          true
        );

      }, [isReviewMode]);

   useEffect(() => {

     if (
       submitted ||
       historyReviewMode
     )
       return;

     const timer =
       setInterval(() => {

         setTimeLeft(t => {

           if (t <= 1) {

             clearInterval(timer);

             handleSubmit();

             return 0;

           }

           return t - 1;

         });

       }, 1000);

     return () =>
       clearInterval(timer);

   }, [
     submitted,
     historyReviewMode
   ]);


  useEffect(() => {

    if (!teacherId || !moduleId) return;

    setLoading(true);

    const reviewData = JSON.parse(
      localStorage.getItem("review_essay_data")
    );

    const currentEssayType = isReviewMode
      ? reviewData?.essayType || "model_papers"
      : essayType;

    fetch(
      `https://edunet.kmechengineering.com/root-engine1/api/essay-free?teacher_id=${teacherId}&module_id=${moduleId}&essay_type=${currentEssayType}&limit=5`
    )
      .then(res => res.json())
      .then(data => {

        console.log("ESSAY API =>", data);

        setEssays(data.essay_data || []);
        setSubjectName(data.subject_name || "");
        setTeacherName(data.teacher_name || "");

        if (isReviewMode && reviewData) {

          setAnswers(reviewData.answers || {});
          setScore(reviewData.marks || 0);
          setSubmitted(true);
          setHistoryReviewMode(true);

        } else {

          setAnswers({});

        }

        setLoading(false);

      })
      .catch(err => {

        console.log("ESSAY API ERROR =>", err);

        setEssays([]);
        setLoading(false);

      });

  }, [teacherId, moduleId, essayType, isReviewMode]);

  useEffect(() => {

    const style =
      document.createElement("style");

    style.innerHTML = `
      @keyframes popupScale {

        from {

          transform: scale(0.6);
          opacity: 0;

        }

        to {

          transform: scale(1);
          opacity: 1;

        }

      }
    `;

    document.head.appendChild(style);

    return () => {

      document.head.removeChild(style);

    };

  }, []);



   const handleSubmit = async () => {

       if (submitting) return;

       setSubmitting(true);

       try {

           const user = JSON.parse(localStorage.getItem("user"));

           let guestToken = localStorage.getItem("guest_token");

           if (!guestToken) {
               guestToken = crypto.randomUUID();
               localStorage.setItem("guest_token", guestToken);
           }

           const response = await fetch(
               "https://edunet.kmechengineering.com/root-engine1/api/essay-save",
               {
                   method: "POST",
                   headers: {
                       "Content-Type": "application/json"
                   },
                   body: JSON.stringify({
                       user_id: user?.id,
                       guest_token: guestToken,
                       subject_id: essays[0]?.subject_id,
                       module_id: moduleId,
                       teacher_id: teacherId,
                       type: "free",
                       essay_type: essayType,
                       answers: answers
                   })
               }
           );

           const data = await response.json();

           if (data.status) {

               const reviewAnswers = {};

               if (Array.isArray(data.answers)) {

                   data.answers.forEach(item => {
                       reviewAnswers[item.essay_id] = item;
                   });

               }

               localStorage.setItem(
                   "review_essay_data",
                   JSON.stringify({
                       answers: reviewAnswers,
                       marks: data.marks,
                       total_marks: data.total_marks,
                       subject_name: subjectName,
                       teacher_name: teacherName,
                       essayType,
                       teacherId,
                       moduleId
                   })
               );

               setScore(data.marks);
               setSubmitted(true);
           }

       } catch (err) {

           console.log("ESSAY SAVE ERROR =>", err);

       } finally {

           setSubmitting(false);

       }

   };



   const handleReview = () => {


     navigate(
       `/essay/paper/${teacherId}?module_id=${moduleId}&review=true`
     );

   };

   const handleRetry = () => {

     setSubmitted(false);

     setAnswers({});

     setScore(0);

     setTimeLeft(
       EXAM_TIME
     );

   };

   const handleContinue = () => {

     setShowPremium(true);

   };

   if (loading) {



    return (

      <div
        style={{
          color: "#fff",
          textAlign: "center",
          marginTop: "100px",
          fontSize: "22px",
          fontWeight: "bold"
        }}
      >

        Loading Essays...

      </div>

    );

  }

  if (essays.length === 0) {

    return (

      <div
        style={{
          color: "#fff",
          textAlign: "center",
          marginTop: "100px",
          fontSize: "22px",
          fontWeight: "bold"
        }}
      >

        No Essays Found

      </div>

    );

  }

  return (

    <EssayLayout
      title={`Free ${essayType.toUpperCase()} Essay (${essays.length})`}
      subject={subjectName || "Subject"}
      teacher={teacherName || "Teacher"}
      questions={essays}
      timeLeft={timeLeft}
      historyReviewMode={historyReviewMode}
      answers={answers}
      submitted={submitted}
      submitting={submitting}
      score={score}
      showPremium={showPremium}
      showContinue={true}
      essayType={essayType}
      setEssayType={setEssayType}

      onAnswer={(id, value) =>
        setAnswers(prev => ({
          ...prev,
          [id]: value
        }))
      }

      onSubmit={handleSubmit}

      onContinue={handleContinue}

      onReview={handleReview}

      onRetry={handleRetry}
    />

  );

  }

/* ================= STYLES ================= */

const pageWrapper = {
  minHeight: "100vh",
  background:"linear-gradient(135deg,#0f172a,#020617)",
  display: "flex",
  justifyContent:"center",
  padding: "40px 15px"

};

const page = {
  width: "100%",
  maxWidth: "900px"
};

const logoBox = {
  textAlign: "center",
  marginBottom: "15px"

};

const logo = {
  width: "90px"
};

const paperTypeBox = {
  background: "#fff",
  padding: "15px",
  borderRadius: "18px",
  marginBottom: "20px",
  display: "flex",
  justifyContent:"center",
  gap: "30px",
  flexWrap: "wrap"
};

const radioLabel = {
  fontSize: "18px",
  fontWeight: "500",
  cursor: "pointer"
};

const examInfoBox = {
  background: "#fff",
  padding: "25px",
  borderRadius: "18px",
  marginBottom: "25px"
};

const examPaper = {
  background: "#fff",
  padding: "35px",
  borderRadius: "20px"
};

const textarea = {
  width: "100%",
  minHeight: "180px",
  padding: "15px",
  borderRadius: "12px",
  border: "1px solid #ccc",
  marginTop: "10px",
  resize: "vertical"

};

const submitBtn = {
  padding: "14px 35px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: "12px",
  cursor: "pointer",
  fontWeight: "bold"

};

const overlayUltra = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.85)",
  backdropFilter: "blur(12px)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999
};

const popupUltra = {
  width: "380px",
  padding: "80px 30px 30px",
  borderRadius: "30px",
  textAlign: "center",
  background: "linear-gradient(135deg,#1e293b,#020617)",
  color: "#fff",
  position: "relative",
  animation: "popupScale 0.35s ease"
};

const topUltra = {
  position: "absolute",
  top: "-60px",
  left: "50%",
  transform: "translateX(-50%)"
};

const titleUltra = {
  marginTop: "20px"
};

const messageUltra = {
  marginBottom: "20px"
};

const btnUltra = {
  width: "100%",
  padding: "14px",
  borderRadius: "16px",
  border: "none",
  background: "linear-gradient(135deg,#22c55e,#16a34a)",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer"
};
